module.exports = __webpack_public_path__ + "static/media/04_4.bc3e7cc5.png";